<div *ngIf="!activeEntityConfig && entityConfigs && Object.keys(entityConfigs).length > 0 && changeActiveEntityConfigWithQueryParams"
     class="all-entities-card-container">

  <rappider-card-icon-title-description-list [items]="entityConfigValuesAsArray"
                                             (doneClick)="onJoyrideDoneButtonClick()"
                                             (cardClick)="onEntitySelectionCardClicked($event)">
  </rappider-card-icon-title-description-list>

</div>
<div *ngIf="!activeEntityConfig && !changeActiveEntityConfigWithQueryParams"
      class="no-config-loading">
  <rappider-spin [spinning]="true"></rappider-spin>
</div>
<rappider-crud-view *ngIf="activeEntityConfig || !changeActiveEntityConfigWithQueryParams"
                    [activeEntityConfig]="activeEntityConfig"
                    [entityConfigs]="entityConfigs!"
                    [entityData]="entityData"
                    [modelNameSingular]="activeEntityConfig?.name!"
                    [mainTitleConfig]="mainTitleConfig!"
                    [mainTitleButtonConfig]="mainTitleButtonConfig!"
                    [mainTitleConfigs]="mainTitleConfigs!"
                    [viewMode]="viewMode"
                    [listMode]="activeEntityConfig?.config?.listMode || ListMode.Grid"
                    [showCreateButton]="true"
                    [createButtonTitle]="createItemTitle"
                    [displayToolbar]="true"
                    [displayToolbarBackButton]="true"
                    [toolbarButtons]="toolbarButtons"
                    [titleBarActionButtons]="titleBarActionButtons"
                    [displayGripButton]="displayGripButton"
                    [listGridData]="activeEntityData"
                    [activeItem]="activeEntityItem"
                    [activeItemId]="activeItemId"
                    [addListGridItemDefaultActions]="addListGridItemDefaultActions"
                    [listGridConfig]="activeEntityConfig?.config?.listGridConfig!"
                    [cardListConfig]="activeEntityConfig?.config?.cardListConfig!"
                    [createFormConfig]="activeEntityConfig?.config?.createItemFormConfig!"
                    [updateFormConfig]="activeEntityConfig?.config?.updateItemFormConfig!"
                    [detailViewConfig]="activeEntityConfig?.config?.detailViewConfig!"
                    [updateFormData]="activeEntityItem"
                    [isListGridDataLoading]="isListGridDataLoading"
                    [joyride]="joyride"
                    [customTemplate]="customTemplate"
                    [detailViewTitleBarActionButtons]="detailViewTitleBarActionButtons"
                    [listViewTitleBarActionButtons]="listViewTitleBarActionButtons"
                    [gridBuilderButton]="true"
                    (cardListItemSelected)="onCardListItemSelected($event)"
                    (cardListItemEditing)="onCardListItemEditing($event)"
                    (cardListActionButtonClicked)="onCardListActionButtonClicked($event)"
                    (gridListItemSelected)="onGridListItemSelected($event)"
                    (viewModeChanged)="onViewModeChanged($event)"
                    (updateFormSubmit)="onUpdateFormSubmit($event)"
                    (createFormSubmit)="onCreateFormSubmit($event)"
                    (itemDeleted)="onItemDeleted($event)"
                    (titleBarActionButtonClicked)="onTitleBarActionButtonClicked($event)"
                    (titleBarActionButtonConfirm)="onTitleBarActionButtonConfirm($event)"
                    (doneClick)="onJoyrideDoneButtonClick()"
                    (toolbarActionButtonClicked)="onToolbarActionButtonClicked($event)"
                    (toolbarBackButtonClicked)="onToolbarBackButtonClicked($event)"
                    (listActionClick)="onListActionClick($event)"
                    (gridBuilderConfigSaved)="onGridBuilderConfigSaved($event)"
                    (listGridVisibilityColumnsChanged)="onListGridVisibilityColumnsChanged($event)"
                    (cardCcsRenderCompleted)="onCardCcsRenderCompleted($event)"
                    (gripButtonClicked)="onGripButtonClicked($event)">
</rappider-crud-view>
